import './index.scss';
import app from './features/app';

// disable BFCache
window.addEventListener('unload', () => {});

app();
